import client from "./client";
import { Report } from "@/interfaces";

export const getReports = () => client.get<Report[]>("reports");

export const createReport = () => client.post<Report>("reports");
